import fonts from './fonts';
import { css } from 'styled-components';

export default {
  'page-title': css`
    font-family: ${fonts.oswald};
    font-size: 30px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.47;
    letter-spacing: normal;
  `,
  'bloc-dashboard-title': css`
    font-family: ${fonts.oswald};
    font-size: 28px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.29;
    letter-spacing: normal;
  `,
  'page-category': css`
    font-family: ${fonts.oswald};
    font-size: 20px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: normal;
  `,
  'block-simple-title': css`
    font-family: ${fonts.oswald};
    font-size: 20px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
  `
};
